import httpService from "./httpService";
import utils from "./utils";
import constants from "../constants";

export default {
  findById(id) {
    return httpService.get(`/menuConfig/${id}`);
  },

  findAll(example, pageable) {
    let params = utils.merge(example, pageable);
    return httpService.get(`/menuConfig/`, {params: params});
  },

  findAllByUserDeptRoleId(userDeptRoleId, pageable) {
    let params = utils.merge({userDeptRoleId: userDeptRoleId}, pageable);
    return httpService.get(`/menuConfig/findAllByUserDeptRoleId`, {
      params: params
    });
  },

  delete(id) {
    return httpService.delete(`/menuConfig/${id}`);
  },

  saveBatch(form) {
    return httpService.post(`/menuConfig/saveBatch`, form);
  },

  isEnableMenu(userDeptRoleId, menuCode) {
    return this.findAll({
      userDeptRoleId: userDeptRoleId,
      menuCode: menuCode,
      status: constants.MENU_CONFIG.STATUS.ACTIVE
    })
      .then(response => {
        let menuConfigs = response.data;
        return !!(menuConfigs && menuConfigs.length);
      });
  },
  getCountingVbMenu(uform) {
    let params = utils.merge(uform);
    return httpService.get(`/menuConfig/getCountingVbMenu`, {params: params});
  },
};



// WEBPACK FOOTER //
// ./src/services/menuConfigService.js